module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "home_index",
    staticClass: "home_index"
  }, [_c('div', {
    staticClass: "index_box"
  }, [_c('form', {
    attrs: {
      "action": "/"
    }
  }, [_c('div', [_c('van-search', {
    attrs: {
      "shape": "round",
      "background": "#f1f3ff",
      "placeholder": "请输入搜索关键词"
    },
    on: {
      "search": _vm.onSearch
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('van-dropdown-menu', {
    attrs: {
      "active-color": "#1989fa"
    }
  }, [_c('van-dropdown-item', {
    attrs: {
      "options": _vm.arealist
    },
    on: {
      "change": _vm.areaChange
    },
    model: {
      value: (_vm.area),
      callback: function($$v) {
        _vm.area = $$v
      },
      expression: "area"
    }
  }), _vm._v(" "), _c('van-dropdown-item', {
    attrs: {
      "options": _vm.typelist
    },
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }), _vm._v(" "), _c('van-dropdown-item', {
    attrs: {
      "options": _vm.timelist
    },
    on: {
      "change": _vm.timeChange
    },
    model: {
      value: (_vm.month),
      callback: function($$v) {
        _vm.month = $$v
      },
      expression: "month"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "examlist_box"
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了",
      "immediate-check": false
    },
    on: {
      "load": _vm.getCalendarList
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "list_box",
      on: {
        "click": function($event) {
          return _vm.gotodetail(item.id)
        }
      }
    }, [_c('img', {
      staticClass: "list_img",
      attrs: {
        "src": item.image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "list_c_b"
    }, [_c('p', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v("报名：" + _vm._s(item.startTime.substring(0, 16) == '1970-01-01 08:00' ? '不详' : item.startTime.substring(0, 10)) + "~" + _vm._s(item.endTime.substring(0, 16) == '1970-01-01 08:00' ? '不详' : item.endTime.substring(0, 10)))]), _vm._v(" "), _c('p', [_vm._v("考试：" + _vm._s(item.doTime.substring(0, 16) == '1970-01-01 08:00' ? '不详' : item.doTime.substring(0, 10)))]), _vm._v(" "), _c('p', [_vm._v("查询：" + _vm._s(item.checkTime.substring(0, 16) == '1970-01-01 08:00' ? '不详' : item.checkTime.substring(0, 10)))])]), _vm._v(" "), _c('van-icon', {
      staticClass: "list_c_r",
      attrs: {
        "name": "arrow",
        "size": "16",
        "color": "#ababab"
      }
    })], 1)
  }), 0)], 1)]), _vm._v(" "), _c('tab-bar', {
    attrs: {
      "current-index": 0
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-bb0da25a"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/examlist.vue
// module id = 703
// module chunks = 1